import { toast } from "react-toastify";
import type { IYoutube } from "./YoutubeMatchingInfo";

export const copyMatchingUsersForExcel = async (users: IYoutube[]) => {
  const clipboardText = users
    .map((data) =>
      [data.partyid, data.uid, data.name, data.nickname]
        .map((value) => String(value ?? "").replace(/[\t\r\n]+/g, " "))
        .join("\t"),
    )
    .join("\n");

  try {
    await navigator.clipboard.writeText(clipboardText);
    toast.success(`${users.length}건의 PID, UID, 이름, 닉네임이 복사되었습니다.`);
    return true;
  } catch {
    toast.error("정보를 복사하는 데에 실패하였습니다.");
    return false;
  }
};

export const copyMatchingUserInfoForExcel = (data: IYoutube) =>
  copyMatchingUsersForExcel([data]);
